import { useEffect, useRef } from "react";
import { LoadingIndicator } from "@lululemon/ecom-site-utils/src/externals/pattern-library/ui-library";
import cs from "classnames";
import PropTypes from "prop-types";
import styles from "./loading-overlay.module.scss";

const LoadingOverlay = ({ loading, loadingText }) => {
  const containerRef = useRef();
  const beforeRef = useRef();
  const afterRef = useRef();

  useEffect(() => {
    const handleFocus = (ev) => {
      const { target } = ev;

      if (target === beforeRef.current) {
        containerRef.current.focus();
      } else if (target === afterRef.current) {
        containerRef.current.focus();
      }
    };

    // Prevent body scroll, add focus listener,
    // and focus on overlay when loading
    if (loading) {
      containerRef.current.focus();
      document.addEventListener("focusin", handleFocus);
      document.body.classList.add(styles.noScroll);
    }

    // Restore body scroll and remove focus listener
    return () => {
      document.removeEventListener("focusin", handleFocus);
      document.body.classList.remove(styles.noScroll);
    };
  }, [loading]);

  if (!loading) return undefined;

  return (
    <>
      {/* eslint-disable jsx-a11y/no-noninteractive-tabindex */}
      <div aria-hidden tabIndex="0" ref={beforeRef} />
      <div
        tabIndex="0"
        role={cs({ alert: loading })}
        ref={containerRef}
        className={cs(styles.overlay, { [styles.hide]: !loading })}
      >
        {loadingText && (
          <span className={cs("OneLinkTx", styles.loadingText)}>
            {loadingText}
          </span>
        )}
        <LoadingIndicator color="red" />
      </div>
      <div aria-hidden tabIndex="0" ref={afterRef} />
      {/* eslint-enable jsx-a11y/no-noninteractive-tabindex */}
    </>
  );
};

LoadingOverlay.propTypes = {
  loading: PropTypes.bool,
  loadingText: PropTypes.string
};

export default LoadingOverlay;
